<template>
  <div class="status-detail-page padding-lr-30">
    <common-header />
    <div class="bg-white padding-bottom-30" style="">
      <section class="detail-card bg-white">
        <div class="padding-tb-30">
          <i class="el-icon-arrow-left text-bold" @click="$router.back()"></i>
          <span class="text-21-color text-bold padding-left-10">投稿详情</span>
        </div>
        <div class="detail-body" v-loading="loading">
          <div class="detail-left">
            <div class="flex align-center margin-bottom-20">
              <span class="w-80 text-21-color">作品文件：</span>
              <div class="file-field flex align-center" @click="handleView">
                <span class="padding-right-10">{{ form.file_name }}</span>
                <img src="@/assets/images/icon7.png" alt="icon" />
                <!-- <span v-if="filePath" class="file-name text-14 text-21-color padding-left-10">{{ filePath }}</span> -->
              </div>
            </div>
            <div
              class="flex align-center margin-bottom-20"
              v-for="field in fields"
              :key="field.label"
            >
              <span class="w-80 text-21-color">{{ field.label }}：</span>
              <span
                class="value text-21-color w-368 h-43 radius-8 line-h-43 padding-left-16 text-14"
                >{{ field.value }}</span
              >
            </div>
            <div class="flex align-center margin-bottom-20">
              <span class="w-80 text-21-color">作品类型：</span>
              <div class="tag-list">
                <span
                  v-for="tag in form.tags"
                  :key="tag"
                  class="tag-pill text-white"
                  >{{ tag }}</span
                >
              </div>
            </div>
            <div class="flex align-center margin-bottom-20">
              <span class="w-80 text-21-color">作品描述：</span>
              <p
                class="value text-21-color w-368 h-43 radius-8 line-h-43 padding-left-16 text-14"
              >
                {{ form.description }}
              </p>
            </div>
            <div class="flex align-center margin-bottom-20">
              <span class="w-80 text-21-color">作品字数：</span>
              <span
                class="value text-000-color text-21-color w-368 h-43 radius-8 line-h-43 padding-left-16 text-14"
                >3分钟/次（新稿前2篇作品开始可以3分钟）</span
              >
            </div>
          </div>
          <div class="detail-right">
            <div class="platform-header">
              <div class="flex align-center">
                <span>平台：</span>
                <span class="text-14 text-000 padding-left-10"
                  >已选：{{ selectedPlatforms.length }} 个</span
                >
              </div>
            </div>

            <div class="platform-favorites-container">
              <div class="platform-list">
                <el-tree
                  :data="treeData"
                  :props="treeProps"
                  node-key="id"
                  :default-expand-all="true"
                  :expand-on-click-node="false"
                  ref="platformTree"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span class="tree-node-content">
                      <img
                        v-if="data.type === 'email'"
                        src="@/assets/images/icon6.png"
                        alt="checkbox"
                        class="w-18 h-18"
                      />
                      <span
                        >{{ node.label
                        }}<span
                          v-if="data.type === 'email' && data.emailData?.email"
                        >
                          ({{ data.emailData.email }})</span
                        ></span
                      >
                    </span>
                  </span>
                </el-tree>
              </div>

              <div class="favorites-address-column">
                <div class="favorites-list">
                  <div class="favorites-header">收藏列表</div>
                  <div
                    class="favorites-content"
                    @scroll="handleFavoritesScroll"
                  >
                    <div
                      v-for="item in favoritesList"
                      :key="item.id"
                      class="favorite-item"
                    >
                      <div class="favorite-item-content">
                        <img
                          src="@/assets/images/icon6.png"
                          alt="checkbox"
                          class="w-18 h-18"
                        />
                        <span
                          >{{ item.editor_name
                          }}<span v-if="item.email">
                            ({{ item.email }})</span
                          ></span
                        >
                      </div>
                    </div>
                    <div
                      v-if="favoritesList.length === 0 && !favoritesLoading"
                      class="empty-favorites"
                    >
                      暂无收藏
                    </div>
                    <div v-if="favoritesLoading" class="loading-favorites">
                      <i class="el-icon-loading"></i> 加载中...
                    </div>
                    <div
                      v-if="
                        favoritesList.length > 0 &&
                        !favoritesHasMore &&
                        !favoritesLoading
                      "
                      class="no-more-favorites"
                    >
                      没有更多了
                    </div>
                  </div>
                </div>

                <div class="address-book-list">
                  <div class="address-book-header">通讯录</div>
                  <div
                    class="address-book-content"
                    @scroll="handleAddressBookScroll"
                  >
                    <div
                      v-for="item in addressBookList"
                      :key="item.id"
                      class="address-book-item"
                    >
                      <div class="address-book-item-content">
                        <span
                          >{{ item.name
                          }}<span v-if="item.email">
                            ({{ item.email }})</span
                          ></span
                        >
                      </div>
                    </div>
                    <div
                      v-if="addressBookList.length === 0 && !addressBookLoading"
                      class="empty-address-book"
                    >
                      暂无通讯录
                    </div>
                    <div v-if="addressBookLoading" class="loading-address-book">
                      <i class="el-icon-loading"></i> 加载中...
                    </div>
                    <div
                      v-if="
                        addressBookList.length > 0 &&
                        !addressBookHasMore &&
                        !addressBookLoading
                      "
                      class="no-more-address-book"
                    >
                      没有更多了
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import { getSubmissionDetail } from "@/api/submission";
import { getFavoriteEditorList, getAddressBookList } from "@/api/dictionary";

export default {
  name: "StatusDetail",
  components: { CommonHeader },
  data() {
    return {
      loading: false,
      form: {
        title: "",
        words: "",
        category: "",
        readerCategory: "",
        readerEmotion: "",
        style: "",
        tags: [],
        description: "",
      },
      platforms: [],
      filePath: "",
      treeData: [],
      treeProps: {
        children: "children",
        label: "label",
      },
      favoritesList: [],
      favoritesPage: 1,
      favoritesLimit: 20,
      favoritesHasMore: true,
      favoritesLoading: false,
      addressBookList: [],
      addressBookPage: 1,
      addressBookLimit: 20,
      addressBookHasMore: true,
      addressBookLoading: false,
    };
  },
  mounted() {
    this.loadFavorites();
    this.loadAddressBook();

    // 从路由参数中获取 id
    const id = this.$route.query.id || this.$route.params.id;
    if (id) {
      this.fetchSubmissionDetail(id);
    } else {
      this.$message.warning("缺少投稿ID参数");
    }
  },
  computed: {
    selectedPlatforms() {
      return this.platforms;
    },
    fields() {
      return [
        { label: "作品名称", value: this.form.title },
        { label: "作品字数", value: this.form.words },
        { label: "作品分类", value: this.form.category },
        { label: "读者分类", value: this.form.readerCategory },
        { label: "读者情绪", value: this.form.readerEmotion },
        { label: "作品风格", value: this.form.style },
      ];
    },
  },
  methods: {
    handleView() {
      window.open(this.form.file_path);
    },
    // 构建树形数据
    buildTreeData() {
      this.treeData = this.platforms.map((platform) => {
        const node = {
          id: `platform_${platform.id}`,
          label: platform.name,
          type: "platform",
          disabled: true,
          children: [],
        };

        // 添加邮箱子节点
        if (platform.emails && Array.isArray(platform.emails)) {
          node.children = platform.emails.map((email) => ({
            id: `email_${platform.id}_${email.id || email.editor_name}`,
            label: email.editor_name,
            type: "email",
            platformId: platform.id,
            emailData: email,
          }));
        }

        return node;
      });
    },
    // 加载收藏列表
    loadFavorites(isLoadMore = false) {
      if (isLoadMore && !this.favoritesHasMore) {
        return;
      }

      if (this.favoritesLoading) {
        return;
      }

      this.favoritesLoading = true;

      const params = {
        page: isLoadMore ? this.favoritesPage : 1,
        limit: this.favoritesLimit,
      };

      getFavoriteEditorList(params)
        .then((response) => {
          this.favoritesLoading = false;

          if (
            response.data &&
            response.data.list &&
            Array.isArray(response.data.list)
          ) {
            const newList = response.data.list.map((item) => ({
              ...item,
              emailId: `email_${item.platform_id}_${item.platform_email_id}`,
            }));

            if (isLoadMore) {
              this.favoritesList = [...this.favoritesList, ...newList];
            } else {
              this.favoritesList = newList;
              this.favoritesPage = 1;
            }

            this.favoritesHasMore = newList.length >= this.favoritesLimit;

            if (isLoadMore && newList.length > 0) {
              this.favoritesPage++;
            }
          } else {
            if (!isLoadMore) {
              this.favoritesList = [];
            }
            this.favoritesHasMore = false;
          }
        })
        .catch((error) => {
          this.favoritesLoading = false;
          console.error("加载收藏列表失败:", error);
          if (!isLoadMore) {
            this.favoritesList = [];
          }
          this.favoritesHasMore = false;
        });
    },
    // 处理收藏列表滚动事件
    handleFavoritesScroll(event) {
      const target = event.target;
      const isBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight < 50;

      if (isBottom && this.favoritesHasMore && !this.favoritesLoading) {
        this.loadFavorites(true);
      }
    },
    // 加载通讯录列表
    loadAddressBook(isLoadMore = false) {
      if (isLoadMore && !this.addressBookHasMore) {
        return;
      }

      if (this.addressBookLoading) {
        return;
      }

      this.addressBookLoading = true;

      const data = {
        page: isLoadMore ? this.addressBookPage : 1,
        limit: this.addressBookLimit,
      };

      getAddressBookList(data)
        .then((response) => {
          this.addressBookLoading = false;

          if (
            response.data &&
            response.data.list &&
            Array.isArray(response.data.list)
          ) {
            const newList = response.data.list;

            if (isLoadMore) {
              this.addressBookList = [...this.addressBookList, ...newList];
            } else {
              this.addressBookList = newList;
              this.addressBookPage = 1;
            }

            this.addressBookHasMore = newList.length >= this.addressBookLimit;

            if (isLoadMore && newList.length > 0) {
              this.addressBookPage++;
            }
          } else {
            if (!isLoadMore) {
              this.addressBookList = [];
            }
            this.addressBookHasMore = false;
          }
        })
        .catch((error) => {
          this.addressBookLoading = false;
          console.error("加载通讯录失败:", error);
          if (!isLoadMore) {
            this.addressBookList = [];
          }
          this.addressBookHasMore = false;
        });
    },
    // 处理通讯录列表滚动事件
    handleAddressBookScroll(event) {
      const target = event.target;
      const isBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight < 50;

      if (isBottom && this.addressBookHasMore && !this.addressBookLoading) {
        this.loadAddressBook(true);
      }
    },
    // 获取投稿详情
    fetchSubmissionDetail(id) {
      this.loading = true;
      getSubmissionDetail(id).then((response) => {
        this.loading = false;
        if (response.data) {
          const data = response.data;

          // 填充表单数据
          this.form.title = data.title || "";
          this.form.words = data.word_count || "";
          this.form.category =
            data.work_category_name ||
            (data.work_category && data.work_category.name) ||
            "";
          this.form.readerCategory =
            data.reader_category_name ||
            (data.reader_category && data.reader_category.name) ||
            "";
          this.form.readerEmotion =
            data.reader_emotion_name ||
            (data.reader_emotion && data.reader_emotion.name) ||
            "";
          this.form.style =
            data.work_style_name ||
            (data.work_style && data.work_style.name) ||
            "";
          this.form.description = data.email_body || "";
          this.form.file_name = data.file_name || "";
          this.form.file_path = data.file_path || "";

          // 处理作品类型（tags）
          if (data.work_types && Array.isArray(data.work_types)) {
            this.form.tags = data.work_types.map((item) => item.name || item);
          } else if (
            data.work_type_names &&
            Array.isArray(data.work_type_names)
          ) {
            this.form.tags = data.work_type_names;
          } else {
            this.form.tags = [];
          }

          // 处理平台信息
          // 一级分类使用 platforms，二级分类使用 platform_records
          if (data.platforms && Array.isArray(data.platforms)) {
            // 先构建平台映射
            const platformMap = {};

            // 从 platforms 获取平台基本信息
            data.platforms.forEach((platform) => {
              const platformId = platform.platform_id || platform.id;
              const platformName =
                platform.platform_name || platform.name || "未知平台";

              platformMap[platformId] = {
                id: platformId,
                name: platformName,
                emails: [],
              };
            });

            // 从 platform_records 获取编辑邮箱信息
            if (data.platform_records && Array.isArray(data.platform_records)) {
              data.platform_records.forEach((record) => {
                const platformId = record.platform_id;
                const editorName = record.editor_name || "";
                const email = record.email || record.contact || "";

                if (platformMap[platformId]) {
                  platformMap[platformId].emails.push({
                    id: record.email_id || record.id,
                    editor_name: editorName,
                    email: email,
                  });
                }
              });
            }

            this.platforms = Object.values(platformMap);
            this.buildTreeData();
          } else {
            this.platforms = [];
            this.treeData = [];
          }

          // 处理文件路径
          if (data.file_path) {
            this.filePath = data.file_path;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.status-detail-page {
  background: #fff6f8;
  min-height: 100vh;
}

.detail-card {
  max-width: 1200px;
  margin: 20px auto;
}

.detail-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.detail-body {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 50px;
  position: relative;
}

.detail-body::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(50%);
  width: 1px;
  background: #f6f6f6;
}

.file-field img {
  width: 28px;
}

.value {
  border: 1px solid #ccd3e1;
}

.tag-list {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.tag-pill {
  padding: 5px 11px;
  border-radius: 20px;
  background: #d85a70;
}

.platform-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;
}

.platform-favorites-container {
  display: flex;
  gap: 16px;
}

.platform-list {
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 14px 18px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
  flex: 1;
  max-width: 400px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.tree-node-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.favorites-address-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 240px;
  flex-shrink: 0;
}

.favorites-list,
.address-book-list {
  border: 1px solid #ebeef5;
  border-radius: 12px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  max-height: 250px;
}

.favorites-content,
.address-book-content {
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-height: 0;
}

.favorites-header,
.address-book-header {
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.favorite-item,
.address-book-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  color: #606266;
  word-break: break-all;
  overflow: hidden;
}

.favorite-item-content,
.address-book-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  overflow: hidden;
  min-width: 0;
}

.favorite-item-content span,
.address-book-item-content span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-favorites,
.empty-address-book {
  text-align: center;
  color: #909399;
  padding: 20px 0;
  font-size: 14px;
}

.loading-favorites,
.loading-address-book {
  text-align: center;
  color: #909399;
  padding: 10px 0;
  font-size: 14px;
}

.no-more-favorites,
.no-more-address-book {
  text-align: center;
  color: #c0c4cc;
  padding: 10px 0;
  font-size: 12px;
}

.platform-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  font-size: 14px;
  color: #606266;
}
</style>
